import './styles.scss';

interface SubsectionMenuProps {
  options: { label: string; id: string }[];
  idSelected: string;
  onChange: (el: string) => void;
}

export const SubsectionMenu = ({ options, idSelected, onChange }: SubsectionMenuProps): JSX.Element => {
  const itemClass = (el: string): string => `item ${idSelected === el ? `active` : ''}`;
  return (
    <ul className="subsection-menu">
      {options.map(({ id, label }) => (
        <li
          key={id}
          className={itemClass(id)}
          onClick={(): void => {
            onChange(id);
          }}
        >
          {label}
        </li>
      ))}
    </ul>
  );
};
